import ReactDOM from "react-dom/client";

import "./i18n";

import App from "./App.tsx";
import DeeplinkService from "./services/DeeplinkService";

import "./styles/Globals.scss";
import "./styles/fonts.scss";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./api/queryClient";
import { registerMaintenanceRecheck } from "./api/organizationStatus.api";

// import styles from "./index.scss";
import * as Sentry from "@sentry/react";
import ConfigService from "./services/ConfigService";
import { setPromoTags, setRouteTag } from "./utils/sentryTags";
import { startCasinoGamePage } from "./widgets/casinoWidget/utils/startCasinoGamePage";

if (import.meta.env.MODE !== "development") {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Profiling and Session Replay are not configured here: our plan does not
    // include them, we never used them, and they only grew the bundle.
    ignoreErrors: [
      "AUTH_SERVICE_ERRORS",
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "DLP has blocked outbound traffic",
      "window.webkit.messageHandlers",
      /Blocked a frame with origin .* from accessing a cross-origin frame/,
      "uncaught exception: undefined",
    ],
  });
  setRouteTag(window.location.pathname);
  setPromoTags({ promoId: ConfigService.getPromoId() });
}

registerMaintenanceRecheck();

const renderApp = () => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    // </React.StrictMode>
  );
};

// Resolve deeplink promoIds (`promoId=dp:<action>`) before mounting the app. For
// non-deeplink loads this is a synchronous no-op; when a redirect is initiated
// we skip mounting so the wrong widget surface never flashes.
if (!DeeplinkService.resolveAndRedirect()) {
  startCasinoGamePage();
  renderApp();
}
